module.exports = __webpack_public_path__ + "img/carousel06.ad466966.webp";